"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldListCoreInputs = exports.DragHandleCoreOptions = void 0;
class DragHandleCoreOptions {
    constructor() {
        this.icon = 'drag_indicator';
        this.position = 'left';
        this.color = '#0000004d';
    }
}
exports.DragHandleCoreOptions = DragHandleCoreOptions;
class EmeraldListCoreInputs {
    constructor() {
        this.isDragable = false;
        this.dragHandleOptions = new DragHandleCoreOptions();
        this.showDragHandler = false;
    }
}
exports.EmeraldListCoreInputs = EmeraldListCoreInputs;
//# sourceMappingURL=list.inputs.js.map